import { render, staticRenderFns } from "./Like.vue?vue&type=template&id=34631e0c&"
import script from "./Like.vue?vue&type=script&lang=ts&"
export * from "./Like.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports